import React from "react";

const incidents = () => {
   return (
      <div className="p-8">
         <h2 className="text-2xl font-bold mb-4">Добро пожаловать на наш новостной сайт!</h2>
         <p>Здесь вы найдете самые свежие новости из разных областей: общество, политика, культура, спорт и многое другое.</p>
         {/* Добавьте больше контента по необходимости */}
      </div>
   );
};

export default incidents;
